









































































































import {Vue, Component } from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {Mall, ReviewDisplayStatusType} from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import ChangeStatusLayer from '@/components/product/review/ChangeStatusLayer.vue';
import ChangeBestLayer from '@/components/product/review/ChangeBestLayer.vue';
import ReportLayer from '@/components/product/review/ReportLayer.vue';
import HistoryLayer from '@/components/product/review/HistoryLayer.vue';
import ReviewTabs from '@/components/product/review/ReviewTabs.vue';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

import {getToday, addDay} from '@/utils/dateUtils';
import {getProductsConfigurationsByAllMall, convertProductUri} from '@/utils/commonUtils';
import {i18nInObjectList} from '@/utils/i18n';
import {ncpPopup} from '@/utils/ncp';
import {htmlEncode} from '@/utils/formatUtils';

const mallModule = namespace('mall');

@Component({
  components: {
    CompSelectBox,
    PeriodDateCalendar,
    ItemTable,
    RadioElement,
    ChangeStatusLayer,
    ChangeBestLayer,
    ReportLayer,
    HistoryLayer,
    ReviewTabs,
    ExcelCreateButton
  }
})
export default class ProductReviewList extends Vue {
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private productDetailUrls: any = [];
  private get mallList() {
    let list: any = [
      {
        value: 0,
        name: this.$t('COMMON_ALL')
      }
    ];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }

  // 등록일
  private startDate: string = addDay(new Date(), -7);
  private endDate: string = getToday();
  private periodOption = {
    period: '1w'
  };

  // 작성자
  private writerName = '';

  // 상세검색
  private searchType = 'PRODUCT_NO';
  private searchTypes = [
    {
      value: 'PRODUCT_NO',
      name: 'PRODUCT_REVIEW_PRODUCT_NO'
    },
    {
      value: 'PRODUCT_NAME',
      name: 'PRODUCT_REVIEW_PRODUCT_NAME'
    },
    {
      value: 'PARTNER_NAME',
      name: 'PRODUCT_REVIEW_SEARCH_TYPE_PARTNER_NAME'
    },
    {
      value: 'REVIEW_NO',
      name: 'PRODUCT_REVIEW_REVIEW_NO'
    }
  ];
  private keyword = '';

  // 전시상태
  private reviewDisplayStatusType = 'ALL';
  private displayStatusType = {
    name: 'displayStatusType',
    data: [
      {
        id: 'displayStatusType_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'displayStatusType_DISPLAY',
        value: 'DISPLAY',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY'
      },
      {
        id: 'displayStatusType_DELETE',
        value: 'DELETE',
        dispaly: 'COMMON_DELETE'
      },
      {
        id: 'displayStatusType_BLIND',
        value: 'BLIND',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND'
      }
    ]
  };

  // 상품평 구분
  private reviewType = 'ALL';
  private reviewTypes = {
    name: 'reviewTypes',
    data: [
      {
        id: 'reviewTypes_ALL',
        value: 'ALL',
        dispaly: 'COMMON_ALL'
      },
      {
        id: 'reviewTypes_NORMAL',
        value: 'NORMAL',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_NORMAL'
      },
      {
        id: 'reviewTypes_BEST',
        value: 'BEST',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_BEST'
      }
    ]
  };

  // 조회
  private size: number = 30;
  private nowPage: number = 1;
  private async search(page: number = 1, size?: number) {
    if (page) {
      this.nowPage = page;
    }
    if (size) {
      this.size = size;
    }
    let request: any = {
      params: {
        startDate: this.startDate,
        endDate: this.endDate,
        reviewType: this.reviewType,
        page: this.nowPage,
        size: this.size
      }
    };
    if (this.mallNo !== 0) {
      request.params.mallNo = this.mallNo;
    }
    if (this.writerName !== '') {
      request.params.writerName = this.writerName;
    }
    if (this.keyword !== '') {
      request.params.searchType = this.searchType;
      request.params.keyword = this.keyword;
    }
    if (this.reviewDisplayStatusType !== 'ALL') {
      request.params.reviewDisplayStatusType = this.reviewDisplayStatusType;
    }

    this.excelRequest = { ...request.params }

    const {data} = await this.$api.getReviews(request);
    this.reviews = data.contents.map((item) => {
      let tempReview = JSON.parse(JSON.stringify(item));
      let displayStatusLabel = '';
      if (item.deleteYn === 'Y' || item.displayStatusType === 'DELETE') {
        displayStatusLabel = window.$t('COMMON_DELETE');
      } else if (item.displayStatusType === 'DISPLAY') {
        displayStatusLabel = window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY');
      } else if (item.displayStatusType === 'BLIND') {
        displayStatusLabel = window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND');
      }
      tempReview.displayStatusLabel = displayStatusLabel;
      tempReview.bestReviewYn = item.isBestReview ? window.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST') : window.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL');
      tempReview.mallProductNo = item.productNo;
      let member = '';
      if (!item.register) {
        member = window.$t('PRODUCT_REVIEW_WRONG_MEMBER');
      } else {
        if (item.register.memberStatus === 'EXPELLED') {
          member = window.$t('PRODUCT_REVIEW_WITHDRAWAL_MEMBER');
        }
        member = item.register.memberId + '(' + item.register.memberNo + ')';
      }
      tempReview.member = member;
      return tempReview;
    });
    this.totalCount = data.totalCount;
    this.gridProps.options.pageOptions.page = this.nowPage;
    this.gridProps.options.pageOptions.perPage = this.size;
    this.gridProps.options.pageOptions.totalCount = data.totalCount;
  }

  // 초기화
  private reset() {
    this.mallNo = 0;
    (this.$refs.periodCalendar as any).clickPeriod('1w');
    this.writerName = '';
    this.searchType = 'PRODUCT_NO';
    this.keyword = '';
    this.reviewDisplayStatusType = 'ALL';
    this.reviewType = 'ALL';
  }

  // 상품조회결과
  private reviews: any = [];
  private totalCount = 0;
  private tableOption = {
    name: 'reviewGrid',
    gridName: 'REVIEW_GRID',
    haveExcelDownBtn: false,
    onLoadSearch: false
  };

  private excelRequest = {
    startDate: this.startDate,
    endDate: this.endDate,
    reviewType: this.reviewType,
    page: this.nowPage,
    size: this.size,
  };

  private gridProps = {
    header: {
      height: 33
    },
    options: {
      columnOptions: {
        resizable: true
      },
      rowHeaders: ['checkbox'],
      rowHeight: 31,
      bodyHeight: 600,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      minRowHeight: 31,
      keyColumnName: 'reviewNo',
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      }
    },
    columns: [
      {
        header: 'PRODUCT_REVIEW_REVIEW_NO',
        name: 'reviewNo',
        align: 'center',
        minWidth: 75,
        formatter: (cell: any) => {
          return `<span class="reviewNo" data-review-no="${cell.value}">${cell.value}</span>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_STATUS_TYPE',
        name: 'displayStatusLabel',
        align: 'center',
        width: 120,
        formatter: ({row}: any) => {
          if (row.deleteYn === 'Y') {
            return window.$t('COMMON_DELETE');
          }

          if (row.externalReview) {
            switch (row.displayStatusType) {
              case 'BLIND':
                return window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND');
              case 'DISPLAY':
                return window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY');
            }
          }
          let blindSelected = row.displayStatusType == 'BLIND' ? 'selected' : '';
          let label = '';
          if (row.displayStatusType === 'DELETE') {
            label = window.$t('COMMON_DELETE');
          } else {
            label = '<div class="inputbox_wrap displayStatusWrap">';
            label += `<select class="selectDisplayStatus h-22" data-review-no="${row.reviewNo}">`;
            label += `<option value="DISPLAY">${window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY')}</option>`;
            label += `<option value="BLIND" ${blindSelected}>${window.$t('PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND')}</option>`;
            label += '</select>';
            label += '</div>';
          }
          return label;
        }
      },
      {
        header: 'PRODUCT_REVIEW_REVIEW_TYPE',
        name: 'bestReviewYn',
        align: 'center',
        minWidth: 120,
        formatter: ({row}: any) => {
          if (row.externalReview || row.deleteYn === 'Y') {
            return row.isBestReview ? window.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST') : window.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL');
          }

          let selectLabel = `<select class="selectBestReviewYn h-22" data-review-no="${row.reviewNo}">`;
          selectLabel += `<option value="N"${row.isBestReview ? '' : 'selected'}>${window.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL')}</option>`;
          selectLabel += `<option value="Y"${row.isBestReview ? 'selected' : ''}>${window.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST')}</option>`;
          selectLabel += '</select>';

          return selectLabel;
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_MALLNO',
        name: 'mallNo',
        align: 'center',
        minWidth: 100,
        formatter: this.formatMallName,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_CONTENT',
        name: 'content',
        align: 'left',
        minWidth: 280,
        formatter: (cell: any) => {
          return `<div class="ellipsis">${htmlEncode(cell.value)}</div>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_RATING',
        name: 'rating',
        align: 'center',
        minWidth: 30
      },
      {
        header: 'PRODUCT_REVIEW_REPORT_CNT',
        name: 'reportCnt',
        align: 'center',
        minWidth: 30,
        formatter: function (cell: any) {
          return `<span class="${cell.value === 0 ? '' : 'reportCnt'}" data-review-no="${cell.row.reviewNo}">${cell.value}</span>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_RECOMMEND_CNT',
        name: 'recommendCnt',
        align: 'center',
        minWidth: 30
      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NO',
        name: 'mallProductNo',
        align: 'center',
        minWidth: 85,
        formatter: this.formatMallProductNo
      },
      {
        header: 'PRODUCT_REVIEW_PRODUCT_NAME',
        name: 'productName',
        align: 'left',
        minWidth: 200,
        formatter: function (cell: any) {
          return `<div class="ellipsis">${cell.value}</div>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_OPTION_NO',
        name: 'mallOptionNo',
        align: 'center',
        minWidth: 80,
        formatter: function ({row}: any) {
          return row.optionNo;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_OPTION_NAME',
        name: 'optionName',
        align: 'left',
        minWidth: 200,
        formatter: function (cell: any) {
          return `<div class="ellipsis">${cell.value}</div>`;
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_PARTNERNAME',
        name: 'partnerName',
        align: 'center',
        minWidth: 100
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_MEMBER',
        name: 'member',
        align: 'center',
        minWidth: 120,
        formatter: ({ row }) => {
          if (!row.register) {
            return window.$t('PRODUCT_REVIEW_WRONG_MEMBER');
          } else {
            const isNaverPay = row.externalReviewSource; // whether it's naverpay member.
            // 탈퇴회원
            if (row.register.memberStatus === 'WITHDRAWN') {
              //EXPELLED
              return window.$t('PRODUCT_REVIEW_WITHDRAWAL_MEMBER');
            }

            //비회원
            if (row.register.memberNo === 0) {
              const displayName =
                isNaverPay && isNaverPay === 'NAVERPAY'
                  ? window.$t('PRODUCT_REVIEW_NAVERPAY_MEMBER') //네이버페이 구매자
                  : row.register.memberName + '(' + window.$t('PRODUCT_REVIEW_NON_MEMBER') + ')'; // {name}(비회원)
              return displayName;
            }

            //회원 and 네이버페이 구매자
            if (row.register.memberNo > 0 && isNaverPay && isNaverPay === 'NAVERPAY') {
              return `<a href="javascript:;" class="memberPopup" data-member-no="${row.register.memberNo}">${window.$t('PRODUCT_REVIEW_NAVERPAY_MEMBER')}(${row.register.memberId})</a>`//네이버페이 구매자({아이디})
            }
            const member = row.register.memberId + '(' + row.register.memberNo + ')';
            return `<a href="javascript:;" class="memberPopup" data-member-no="${row.register.memberNo}">${member}</a>`;
          }
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_ORDERNO',
        name: 'orderNo',
        align: 'center',
        minWidth: 150,
        formatter: function (cell: any) {
          return cell.value ? cell.value : '-';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_REGISTER_DATE_TIME',
        name: 'registerYmdt',
        align: 'center',
        minWidth: 150,
        formatter: function ({row}: any) {
          return row.registerDateTime;
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'PRODUCT_REVIEW_HEADER_HISTORY',
        name: 'history',
        align: 'center',
        minWidth: 85,
        formatter: function (cell: any) {
          return `<span class="historyView" data-review-no="${cell.row.reviewNo}">${window.$t('PRODUCT_REVIEW_VIEW')}</span>`;
        }
      }
    ]
  };
  private formatMallName(cell: any) {
    let mallInfo = this.malls.find((mall: Mall) => mall.mallNo === cell.value);
    if (mallInfo) {
      return mallInfo.mallName;
    }
    return '';
  }
  private formatMallProductNo(cell: any) {
    let tempConfig = this.productDetailUrls.find((item) => item.mallNo === cell.row.mallNo);
    let uri = '';
    if (tempConfig) {
      uri = convertProductUri(tempConfig.productDetailUrl, cell.row.productNo);
    }
    return `<a target="_blank" href="${uri}" >${cell.row.productNo}</a>`;
  }
  private openReviewDetailPopup(e: any) {
    let reviewNo = $(e.target).data('review-no');
    (window as any).detailCallBack = this.detailCallBack;
    sessionStorage.setItem('reviewDetailFrom', 'ReviewList');
    ncpPopup(`/review/${reviewNo}`, 'reviewDetailPopup', 1024, 800);
  }
  private detailCallBack() {
    (window as any).detailCallBack = undefined;
    sessionStorage.removeItem('reviewDetailFrom');
    this.search();
  }
  private async editDisplayStatus(e: any) {
    let reviewNo = $(e.target).data('review-no');
    let displayStatusType = $(e.target).val() as ReviewDisplayStatusType;
    let request = {
      pathParams: {
        reviewNo
      },
      data: {
        reason: '',
        displayStatusType
      }
    };
    await this.$api.putReviewsReviewNoStatus(request);
    await this.search();
  }
  private async editBestReviewYn(e: any) {
    let reviewNo = $(e.target).data('review-no');
    let bestReviewYn = $(e.target).val() as ReviewDisplayStatusType;
    let request = {
      data: {
        reviewNos: [reviewNo],
        bestReviewYn
      }
    };
    await this.$api.putReviewsBestReview(request);
    await this.search();
  }
  private showReportLayer = false;
  private reportList: any[] = [];
  private tempReviewNo = '';
  private async onClickReportCnt(e: any) {
    let reviewNo = $(e.target).data('review-no');
    let request = {
      pathParams: {
        reviewNo
      }
    };
    let {data} = await this.$api.getReviewsReviewNoReports(request);
    this.reportList = data;
    this.tempReviewNo = reviewNo;
    this.showReportLayer = true;
  }
  private onClickMemberPopup(e: any) {
    const memberNo = $(e.target).data('member-no');
    ncpPopup(`/member/popup/crm/${memberNo}`, window.$t('PRODUCT_REVIEW_POP_CRM'), 1100, 980);
  }
  private showHistoryLayer = false;
  private historyList: any[] = [];
  private async onClickHistoryView(e: any) {
    let reviewNo = $(e.target).data('review-no');
    let request = {
      pathParams: {
        reviewNo
      }
    };
    let {data} = await this.$api.getReviewsReviewNoHistories(request);
    this.historyList = data;
    this.showHistoryLayer = true;
  }
  // 전시상태 변경
  private showChangeStatusLayer = false;
  private changeStatusInfo: any = {};
  private changeStatus() {
    let reviewNos = (this.$refs.reviewGrid as any).getCheckedRowKeys();
    if (reviewNos.length > 0) {
      (window as any).changeStatusCallBack = this.changeStatusCallBack;
      sessionStorage.setItem('reviewNos', JSON.stringify(reviewNos));
      sessionStorage.setItem('callBack', 'changeStatusCallBack');
      ncpPopup('/review/changeDisplayStatus', 'changeDisplayStatusPopup', 450, 230);
    } else {
      alert(this.$t('PRODUCT_REVIEW_ERR_NOT_SELECTED'));
    }
  }
  private changeStatusCallBack(res: any) {
    (window as any).changeStatusCallBack = undefined;
    sessionStorage.removeItem('reviewNos');
    sessionStorage.removeItem('callBack');
    this.changeStatusInfo = res;
    this.showChangeStatusLayer = true;
  }
  // 상품평 구분 변경
  private showChangeBestLayer = false;
  private changeBestInfo: any = {};
  private changeBest() {
    let reviewNos = (this.$refs.reviewGrid as any).getCheckedRowKeys();
    if (reviewNos.length > 0) {
      (window as any).changeBestCallBack = this.changeBestCallBack;
      sessionStorage.setItem('reviewNos', JSON.stringify(reviewNos));
      sessionStorage.setItem('callBack', 'changeBestCallBack');
      ncpPopup('/review/changeBestReview', 'changeBestReviewYnPopup', 450, 500);
    } else {
      alert(this.$t('PRODUCT_REVIEW_ERR_NOT_SELECTED'));
    }
  }
  private changeBestCallBack(res: any) {
    (window as any).changeBestCallBack = undefined;
    sessionStorage.removeItem('reviewNos');
    sessionStorage.removeItem('callBack');
    this.changeBestInfo = res;
    this.showChangeBestLayer = true;
  }
  private closeChangeLayer() {
    this.showChangeStatusLayer = false;
    this.showChangeBestLayer = false;
    this.search();
  }

  private async mounted() {
    await this.fetchMalls();
    if (this.malls.length === 1) {
      this.mallNo = this.malls[0].mallNo;
    }
    this.productDetailUrls = await getProductsConfigurationsByAllMall();
    await this.search(1);

    $('#wrap').on('click', '.reviewNo', $.proxy(this.openReviewDetailPopup, this));
    $('#wrap').on('change', '.selectDisplayStatus', $.proxy(this.editDisplayStatus, this));
    $('#wrap').on('change', '.selectBestReviewYn', $.proxy(this.editBestReviewYn, this));
    $('#wrap').on('click', '.reportCnt', $.proxy(this.onClickReportCnt, this));
    $('#wrap').on('click', '.memberPopup', $.proxy(this.onClickMemberPopup, this));
    $('#wrap').on('click', '.historyView', $.proxy(this.onClickHistoryView, this));
  }
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
}
